import * as React from 'react';
import { useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { useLogin, useNotify, Notification } from 'react-admin';
import { ThemeProvider } from '@material-ui/core/styles';
import { Container, CssBaseline, Avatar, Typography, TextField, Button, Link, Box, Grid } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { theme, useFormStyles, Copyright } from './theme';

export const LoginPage = () => {
    const TITLE = 'Sign In';
    const classes = useFormStyles();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const login = useLogin();
    const notify = useNotify();
    const submit = e => {
        e.preventDefault();
        // will call authProvider.login({ email, password })
        login({ username, password }).catch(() =>
            notify('Invalid username or password')
        );
    };

    return (
        <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar} >
                <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                {TITLE}
                </Typography>
                <form className={classes.form} onSubmit={submit}>
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="Username"
                    name="Username"
                    label="Username"
                    autoFocus
                    onChange={e1 => setUsername(e1.target.value)}
                />
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="password"
                    name="password"
                    label="Password"
                    type="password"
                    onChange={e2 => setPassword(e2.target.value)}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                >
                    {TITLE}
                </Button>
                <Grid container>
                    <Grid item xs>
                    <Link href="#/loginPasswordForgot" variant="body2">
                        Forgot password?
                    </Link>
                    </Grid>
                </Grid>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
            <Notification/>
        </Container>
        </ThemeProvider>
    );
};

export const LoginPasswordForgot = () => {
    const TITLE = 'Forgot Password';
    const classes = useFormStyles();
    const [username_or_email, setUsernameOrEmail] = useState('');
    const submit = e => {
        e.preventDefault();
        const request = new Request(window.nobid_endpoint+'/users/forgotpwd', {
            method: 'POST',
            body: JSON.stringify({ username_or_email }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
        return fetch(request)
            .then(response => {
               return response.json();
            })
            .then((json) => {
                if (!json.success) NotificationManager.error(json.message, `Error - ${TITLE}`);
                else NotificationManager.success(json.message, 'Important message');
            })
            .catch((error) => {
                NotificationManager.error(`${error}`, 'Error');
            });
    };

    return (
        <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                {TITLE}
                </Typography>
                <form className={classes.form} onSubmit={submit}>
                Please enter your username or email address and you will receive a link to reset your password via email. Look for the email in your Inbox and Spam folder as well.
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="username_or_email"
                    name="username_or_email"
                    label="Username or email addess"
                    autoFocus
                    onChange={e1 => setUsernameOrEmail(e1.target.value)}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                >
                    Get New Password
                </Button>
                <Grid container>
                    <Grid item xs>
                    <Link href="#/login" variant="body2">
                        Sign in
                    </Link>
                    </Grid>
                </Grid>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
            <Notification/>
        </Container>
        </ThemeProvider>
    );
};

export const LoginPasswordReset = () => {
    const TITLE = 'Reset Password';
    const classes = useFormStyles();
    const [new_password, setNewPassword] = useState('');
    const [new_password_confirm, setNewPasswordConfirmation] = useState('');
    const qs = window.location.hash.substring(window.location.hash.indexOf('?')+1);
    const queryParameters = new URLSearchParams(qs);
    const token = queryParameters.get("token");
    const submit = e => {
        e.preventDefault();
        const request = new Request(window.nobid_endpoint+'/users/resetpwd', {
            method: 'POST',
            body: JSON.stringify({ new_password, token }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
        return fetch(request)
            .then(response => {
               return response.json();
            })
            .then((json) => {
                if (!json.success) NotificationManager.error(json.message, 'Important message');
                else NotificationManager.success(json.message, 'Important message');
            })
            .catch((error) => {
                NotificationManager.error(`Exception - ${error}`, 'Error');
            });
    };

    return (
        <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                {TITLE}
                </Typography>
                <form className={classes.form} onSubmit={submit}>
                Please enter your new password below. The Password Confirmation field must match your new password.
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="new_password"
                    name="new_password"
                    label="New Password"
                    type="password"
                    autoFocus
                    onChange={e1 => setNewPassword(e1.target.value)}
                />
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="new_password_confirm"
                    name="new_password_confirm"
                    label="New Password Confirmation"
                    type="password"
                    error={new_password_confirm !== new_password}
                    helperText={new_password_confirm !== new_password ? 'Field New Password Confirmation must match New Password above.' : ''}
                    onChange={e2 => setNewPasswordConfirmation(e2.target.value)}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                >
                    {TITLE}
                </Button>
                <Grid container>
                    <Grid item xs>
                    <Link href="#/login" variant="body2">
                        Sign in
                    </Link>
                    </Grid>
                    <Grid item>
                    <Link href="#/loginPasswordForgot" variant="body2">
                        Forgot password?
                    </Link>
                    </Grid>
                </Grid>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
            <Notification/>
        </Container>
        </ThemeProvider>
    );
};